import { createReducer } from 'lib/utilities';

const initialState = () => {
  const initialUrlParams = new URLSearchParams(window.location.search);
  return {
    offset: 0,
    selectedPhoneNumber: undefined,
    sidebarLoading: false,
    paginationLoading: false,
    rehydrationEventId: initialUrlParams.get('eid') || undefined,
  };
};

export default createReducer(initialState(), {
  inboxDeleteRehydrationEventId: (state, payload) => ({ ...state, rehydrationEventId: null }),
  inboxSetSidebarLoading: (state, payload) => ({ ...state, sidebarLoading: payload }),
  inboxSetPaginationLoading: (state, payload) => ({ ...state, paginationLoading: payload }),
  inboxSetSelectedPhoneNumber: (state, payload) => ({ ...state, inboxSetSelectedPhoneNumber: payload }),
  inboxResetReducer: (state) => ({ ...initialState() }),
});
